// SAT Module - Main Zone Component
import { DsIcon } from '@ice-web-app/designSystem';
import { loadModuleNamespace } from '@ice-web-app/shared-i18n';
import { useGlobalStore, useSidebarStore } from '@ice-web-app/shared-store';
import { getCurrentEcosystemBasePath } from '@ice-web-app/shared-utils';
import { type FC, useEffect } from 'react';
import { sat4AR, sat4DE, sat4EN } from '../locales';
import { ZoneRoutes } from '../routes/ZoneRoutes';
import { routes } from '../routes/routes';

import { ConvexProvider, ConvexReactClient } from 'convex/react';

const convex = new ConvexReactClient(import.meta.env.VITE_CONVEX_URL as string);

const SatModuleContent: FC = () => {
  const { setMenuItems, setShowEntityMenu, setBackPath } = useSidebarStore();
  const { setShowMainSidebar } = useGlobalStore();
  const showMainSidebar = localStorage.getItem('showMainSidebar') === 'true';

  useEffect(() => {
    setShowMainSidebar(showMainSidebar);
  }, [showMainSidebar, setShowMainSidebar]);

  useEffect(() => {
    setShowEntityMenu(false);
  }, [setShowEntityMenu]);

  useEffect(() => {
    setBackPath(getCurrentEcosystemBasePath() || '/');
    setMenuItems([
      {
        title: 'Settings',
        icon: <DsIcon icon="FRAME" />,
        path: routes.settings,
      },
      {
        title: 'Curriculum Plan',
        icon: <DsIcon icon="TABLE" />,
        path: routes.curriculumPlan,
      },
      {
        title: 'School Structure',
        icon: <DsIcon icon="PLANNING" />,
        path: routes.schoolStructure,
      },
      {
        title: 'Teachers',
        icon: <DsIcon icon="TEACHER" />,
        path: routes.teachers,
      },
      {
        title: 'Rules & Preferences',
        icon: <DsIcon icon="SETTING" />,
        path: routes.rulesPreferences,
      },
      {
        title: 'Timetable Management',
        icon: <DsIcon icon="SCHEDULE_PLANNER" />,
        path: routes.createTimetable,
        submenu: [
          { title: 'Create Timetable', path: routes.createTimetable },
          { title: 'Timetable Views', path: routes.timetable },
        ],
      },
    ]);

    return () => {
      setBackPath('');
    };
  }, [setMenuItems, setBackPath]);

  useEffect(() => {
    loadModuleNamespace('satModule', [
      { jsonFile: sat4AR, lang: 'ar' },
      { jsonFile: sat4DE, lang: 'de' },
      { jsonFile: sat4EN, lang: 'en' },
    ]);
  }, []);

  return <ZoneRoutes />;
};

export const SatModule: FC = () => {
  return (
    <ConvexProvider client={convex}>
      <SatModuleContent />
    </ConvexProvider>
  );
};

export default SatModule;
